import { Box, useTheme } from "@mui/material";
import React from "react";

interface PaginationButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

export function PaginationButton({
  children,
  onClick,
  disabled,
}: PaginationButtonProps) {
  const theme = useTheme();

  return (
    <Box
      onClick={!disabled ? onClick : undefined}
      sx={{
        position: "relative",
        overflow: "hidden",
        width: 36,
        height: 36,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        color: "#fff",
        opacity: disabled ? 0.4 : 1,
        background: theme.palette.primary.main,
        transition: "0.25s ease",
        zIndex: 1,

        "&::before": {
          content: '""',
          position: "absolute",
          width: 0,
          height: 0,
          left: "50%",
          top: "50%",
          backgroundColor: "#000",
          borderRadius: "50%",
          transform: "translate(-50%, -50%)",
          transition:
            "width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          zIndex: -1,
        },

        ...(!disabled && {
          "&:hover::before": {
            width: 80,
            height: 80,
          },
        }),
      }}
    >
      {children}
    </Box>
  );
}
